import { TableCell, TableHead, TableRow } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { VacancyTableHeaderProps } from 'features/VacanciesModal/types';

export const VacancyTableHeader: React.FC<VacancyTableHeaderProps> = ({ columns }) => {
  return (
    <TableHead data-testid={ATSVacanciesModalTestIds.VACANCY_TABLE_HEADER}>
      <TableRow>
        {columns.map((column) => (
          <TableCell key={column.id} align={column.align || 'left'} sx={column.sx || null}>
            {column.content}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
